import React from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { t } from 'utils/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
} from "@mui/material";
import styles from './ConfirmDialog.module.css';

const ConfirmDialog = (props) => {
  const {
    title,
    open,
    children,
    cancelLabel,
    confirmLabel,
    onConfirm,
    onCancel,
    ConfirmButtonProps,
    CancelButtonProps,
    ...other
  } = props;

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      disableEscapeKeyDown
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title" disableTypography>
        <Typography component="h2" variant="h6" classes={{ root: styles.title }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions>
        {cancelLabel && (
          <Button autoFocus color="primary" {...CancelButtonProps} onClick={onCancel}>
            {cancelLabel}
          </Button>
        )}
        {confirmLabel && (
          <Button color="primary" {...ConfirmButtonProps} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  title: Type.string.isRequired,
  children: Type.node.isRequired,
  open: Type.bool.isRequired,
  cancelLabel: Type.string,
  confirmLabel: Type.string,
  ConfirmButtonProps: Type.shape({
    show: Type.bool,
  }),
  CancelButtonProps: Type.shape({
    show: Type.bool,
  }),
  onCancel: Type.func,
  onConfirm: Type.func,
};

ConfirmDialog.defaultProps = {
  onCancel: noop,
  onConfirm: noop,
  cancelLabel: t('cancel'),
  confirmLabel: t('ok'),
  ConfirmButtonProps: {},
  CancelButtonProps: {},
};

export default ConfirmDialog;
